import i18n from '~/components/i18n'

export const dynamicOffersPreviewColumns = (priceLabel: string, amountUnit) => ([
  {
    name: i18n.t('Trading month'),
    key: 'date',
    type: 'dateRibbon',
    format: 'MMM YYYY'
  },
  {
    name: i18n.t('Fixed price {{priceLabel}}', { priceLabel }),
    key: 'price',
    type: 'no-unit-number'
  },
  {
    name: i18n.t('Offered amount (in {{amountUnit}})', { amountUnit }),
    key: 'offeredAmount',
    type: 'number'
  },
  {
    name: i18n.t('Confirmed trading amount (in {{amountUnit}} / in %)', { amountUnit }),
    key: 'confirmedAmount',
    type: 'confirm'
  },
  {
    name: i18n.t('Revenue (in €)'),
    key: 'total',
    type: 'no-unit-number'
  },
  {
    name: i18n.t('Actions'),
    type: 'action'
  }
])

export const dynamicConfirmOffersColumns = (amountUnit) => ([
  {
    name: i18n.t('Trading month'),
    key: 'date',
    type: 'dateRibbon',
    format: 'MMM YYYY'
  },
  {
    name: i18n.t('Offered amount (in {{amountUnit}})', { amountUnit }),
    key: 'offeredAmount',
    type: 'number'
  },
  {
    name: i18n.t('Confirmed trading amount (in {{amountUnit}} / in %)', { amountUnit }),
    key: 'confirmedAmount',
    type: 'confirm'
  }
])

export const dynamicParticipientFarmersColumns = (amountUnit) => [
  {
    name: i18n.t('Farmer'),
    key: 'companyName'
  },
  {
    name: i18n.t('Offer ID'),
    key: 'uniqueId'
  },
  {
    name: i18n.t('Offer date'),
    key: 'createdAt',
    type: 'date',
    format: ('DD.MM.YYYY HH:mm')
  },
  {
    name: i18n.t('Status'),
    key: 'statusLabel'
  },
  {
    name: i18n.t('Offered amount (in {{amountUnit}})', { amountUnit }),
    key: 'amount',
    type: 'number'
  },
  {
    name: i18n.t('Confirmed trading amount (in {{amountUnit}} / in %)', { amountUnit }),
    type: 'confirm'
  },
  {
    name: i18n.t('Total (in €)'),
    key: 'total',
    type: 'price-total'
  }
]

export const actions = [
  {
    popupMessage: i18n.t('Enter confirmed amount'),
    type: 'icon',
    name: 'handshake outline',
    size: 'large',
    actionType: 'enterConfirmed'
  },
  {
    popupMessage: i18n.t('Participated farmers'),
    type: 'icon',
    name: 'group',
    size: 'large',
    actionType: 'participated'
  }
]

export const actionsForLightUser = [
  {
    popupMessage: i18n.t('Participated farmers'),
    type: 'icon',
    name: 'group',
    size: 'large',
    actionType: 'participated'
  }
]

export const actionsForOperative = [
  {
    popupMessage: i18n.t('Enter confirmed amount'),
    type: 'icon',
    name: 'handshake outline',
    size: 'large',
    actionType: 'enterConfirmed'
  }
]